import React from 'react';
import { cn } from '../../utils/cn';

export interface SectionProps {
  title: string;
  icon?: React.ReactNode;
  description?: React.ReactNode;
  children: React.ReactNode;
  id?: string;
  className?: string;
}

/**
 * A flat group (heading + content), used for form groups and settings blocks instead of a Card.
 * Adjacent Sections in the same container are separated by a top border; the first one has none.
 */
export const Section: React.FC<SectionProps> = ({ title, icon, description, children, id, className }) => (
  <section id={id} className={cn('mt-6 border-t border-line pt-6 first:mt-0 first:border-t-0 first:pt-0', className)}>
    <div className="mb-1 flex items-center gap-2">
      {icon && (
        <span className="text-muted" aria-hidden="true">
          {icon}
        </span>
      )}
      <h2 className="font-display text-lg font-semibold text-ink">{title}</h2>
    </div>
    {description && <p className="mb-4 text-sm text-muted">{description}</p>}
    <div>{children}</div>
  </section>
);
